export const taskPriority = [
  // { id: -1, name: "none" },
  { id: 0, name: "low" },
  { id: 1, name: "normal" },
  { id: 2, name: "high" },
];
